<template>
  <div v-if="hasPriceList">
    <ul class="nav collage-photo-item__actions">
      <li class="nav-item">
        <ButtonToggleCart :loading="loading" :action="actionCart" @click="toggleSelection()"/>
      </li>
    </ul>
  </div>

</template>

<script>
import ButtonToggleCart from "@/domain/galleries/components/ButtonToggleCart.vue";
import {cartActions} from "@/domain/galleries/constants";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CartActions",
  components: {ButtonToggleCart},
  data() {
    return {
      loading: false,
    }
  },
  props: {
    media: {
      type: Object,
      required: true
    },
    digitalItemId: {
      type: Number,
      default: null
    },
    gallery: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('checkinDetail', ['picaCode', 'checkin']),
    ...mapGetters('cartDigitalItems', ['mediaIsInCart', 'mediaInCartCount']),
    hasPriceList() {
      if (!this.gallery.price_list) return false
      return true
    },
    actionCart() {
      return this.inCart ? cartActions.REMOVE : cartActions.ADD
    },
    inCart() {
      return this.mediaIsInCart(this.digitalItemId, this.media.id)
    }
  },

  methods: {
    ...mapActions('cartDigitalItems', [
      'fetchDigitalItemsTotals',
      'createDigitalItem',
      'addMediasToDigitalItem',
      'removeMediasFromDigitalItem',
      'removeDigitalItem']),

    toggleSelection() {
      this.inCart ? this.removeFromCart() : this.addToCart()
    },

    async addToCart() {
      this.loading = true
      const mediaIds = [this.media.id]
      try {
        if (this.digitalItemId) {
          const params = {'media_ids': mediaIds}
          await this.addMediasToDigitalItem({
                digitalItemId: this.digitalItemId,
                params: params
              }
          )
        } else {
          await this.createDigitalItem({
            order_type: 'photolist',
            media_ids: mediaIds,
            checkin_id: this.checkin.id,
            gallery_id: this.gallery.id
          })
        }
      } catch (error) {
        const responseError = error.response
        if (responseError.status === 400) {
          if (responseError.data.code === 'cart_currency_mismatch') {
            this.$bvModal.show('modal-currency-mismatch')
          } else if (responseError.data.code === 'purchase_disabled') {
            this.$bvToast.toast(responseError.data.detail, {
              title: this.$t('collage_photo_item.purchase_not_available'),
              headerClass: 'd-block pt-2',
              autoHideDelay: 5000,
              toaster: 'b-toaster-top-center'
            });
          }
        }
      } finally {
        await this.fetchDigitalItemsTotals()
        this.loading = false
      }
    },

    async removeFromCart() {
      this.loading = true

      if (this.mediaInCartCount(this.digitalItemId) === 1) {
        await this.removeDigitalItem(this.digitalItemId)
      } else {
        const mediaIds = [this.media.id]
        const params = {'media_ids': mediaIds}
        await this.removeMediasFromDigitalItem({
          digitalItemId: this.digitalItemId,
          params: params,
        })
      }

      await this.fetchDigitalItemsTotals()
      this.loading = false

    }
  },
}
</script>


<style scoped>

</style>